module.exports = __webpack_public_path__ + "media/images/icons/icn_053-ae9d2f75666242e2e22bfa850797f603.svg";